import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

import ContentWrapper from 'components/core/content-wrapper';

export function TwoColumn({ children, ...props }) {
  return (
    <ContentWrapper {...props}>
      <Container className='two-column-content'>{children}</Container>
    </ContentWrapper>
  );
}

const Container = styled.div`
  display: flex;
  padding: 60px 0 0;
  ${space}
`;

export const TwoColumnSidebar = styled.aside`
  border-right: 1px solid var(--dcm-filter-border-color, ${({ theme }) => theme.colors.blueGrey[90]});
  font-family: var(--dcm-font-secondary);
  height: max-content;
  margin-right: 39px;
  width: 191px;

  ${({ $stickyStyle }) =>
    $stickyStyle &&
    Object.keys($stickyStyle).length > 0 &&
    `
    position: ${$stickyStyle.position || 'static'};
    top: ${$stickyStyle.top || 'auto'};
    transform: ${$stickyStyle.transform || 'none'};
    transition: ${$stickyStyle.transition || 'none'};
    overflow-y: ${$stickyStyle.overflowY || 'visible'};
    max-height: ${$stickyStyle.maxHeight || 'none'};
  `}
  /* Left align .view-more-link-toggle */
  & [class*='view-more-link-toggle'] {
    text-align: left;
  }
`;

export const TwoColumnContent = styled.div`
  flex: 1 0 0%;
  min-width: 0;
`;
